export default "__VITE_ASSET__bHuUWOur__"